'use client'

import { Carousel, Image } from '@/shared/ui'

import { useCarousel } from '../../lib/carousel'
import { MobileImageGallery } from '../image-gallery'

type Props = {
  images: string[]
  roomName: string
  roomUrl: string | null
  className?: string
}

export const MobileRoomImageCarousel = ({
  images,
  roomName,
  roomUrl,
  className,
}: Props) => {
  const {
    selectedImageIndex,
    isGalleryOpen,
    handleThumbnailClick,
    handleContextMenu,
    handleGalleryClose,
  } = useCarousel()

  return (
    <>
      <Carousel.Provider
        orientation="horizontal"
        options={{ loop: true, align: 'start' }}
        className={className}
      >
        <Carousel.Root>
          <Carousel.Content className="m-0 md:-ml-4">
            {images.map((image, index) => (
              <Carousel.Item
                key={image}
                className="aspect-375/280 w-full p-0 md:h-[320px] md:basis-[444px] md:pl-4"
              >
                <Image
                  src={image}
                  alt={roomName}
                  width={375}
                  height={280}
                  className="select-none"
                  placeholder
                  onClick={() => {
                    handleThumbnailClick(index)
                  }}
                  onContextMenu={handleContextMenu}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                  imageStyle={{
                    width: '100%',
                  }}
                />
              </Carousel.Item>
            ))}
          </Carousel.Content>
          <Carousel.SnapDisplay className="bottom-3 md:bottom-4 md:left-[214px] md:-translate-x-1/2" />
        </Carousel.Root>
      </Carousel.Provider>
      <MobileImageGallery
        open={isGalleryOpen}
        onClose={handleGalleryClose}
        selectedIndex={selectedImageIndex}
        images={images}
        roomName={roomName}
        roomUrl={roomUrl}
      />
    </>
  )
}
